<template>
  <Button icon="pi pi-map" @click="toggleLayerManager($event)" class="shadow-md" />
  <Popover ref="op">
    <div class="flex flex-col gap-4 w-[16rem]">
      <div>
        <Listbox
          v-model="activeBaseLayer"
          :options="layers.base"
          optionLabel="label"
          optionValue="id"
          @change="onChange"
        />
      </div>
      <Divider />
      <div class="flex flex-col gap-2">
        <div v-for="option in layers.info" :key="option.id" class="flex items-center justify-between">
          <p>{{ option.label }}</p>
          <ToggleSwitch
            v-model="selected[option.id]"
            @update:model-value="onToggle"
          />
        </div>
      </div>
    </div>
  </Popover>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { onMounted, ref } from 'vue'
import { useMapStore } from '@/stores/map'

const mapStore = useMapStore()
const { activeBaseLayer, layers, activeInfoLayers } = storeToRefs(mapStore)

const selected = ref({})
const op = ref(null)

const toggleLayerManager = event => {
  if (op.value) {
    op.value.toggle(event)
  }
}

onMounted(() => {
  if (layers.value) {
    init()
  }
})

const init = () => {
  if (!activeBaseLayer.value) {
    const active = layers.value.base.find(layerConf => layerConf.visible)
    activeBaseLayer.value = active ? active.id : null
  }

  selected.value = Object.fromEntries(
    layers.value.info.map(layerConf => {
      return [layerConf.id, layerConf.visible || false]
    }),
  )
}

const onChange = e => {
  activeBaseLayer.value = e.value
}

const onToggle = () => {
  activeInfoLayers.value = Object.keys(selected.value).filter(
    id => selected.value[id],
  )
}
</script>
